var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 63,
    viewBox: "0 0 46 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4691 61.0278H26.8025V51.4251M19.4691 60.7878V51.4251M19.4691 51.4251V45.6635H26.8025V51.4251M19.4691 51.4251C10.7778 51.4251 1 42.0625 1 30.0591H44.8083V30.0591C44.9142 30.0591 45.0001 30.1451 44.9991 30.251C44.8971 40.9869 36.2524 51.4251 26.8025 51.4251M8.06173 24.5376H15.3951M31.1481 24.5376H38.4815M8.06173 18.5359H15.3951M31.1481 18.5359H38.4815M31.1481 13.0144H38.4815M15.3951 13.0144H8.06173M8.06173 13.0144C8.06173 13.0144 8.06173 23.0972 8.06173 34.3804C8.06173 45.6635 32.7778 52.8655 38.4815 34.3804V12.7743C37.2454 -3.13556 8.67675 -2.31948 8.06173 11.814V13.0144Z",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector55);
export default __webpack_public_path__ + "static/media/Vector 55.21cc7e2b7f32382beaedf2c4f91ba495.svg";
export { ForwardRef as ReactComponent };